import React from "react";
import styles from "./FilterLayout.module.scss";

interface IFilterFieldProps {
	label: string;
	children: React.ReactNode;
}

export const FilterField: React.FC<IFilterFieldProps> = ({ label, children }) => (
	<div className={styles.field}>
		<div className={styles.fieldLabel}>{label}</div>
		{children}
	</div>
);
